import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { leagueIds, ratePlanCodes, sportIds, videos } from 'src/constants'
import { useCheckFanduelRSN } from 'src/modules/hooks/useCheckFanduelRSN'

export default (props) => {
  const { showFDPlanCards, rsnData } = useCheckFanduelRSN()

  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      title={'Watch MLB live with Fubo'}
      subtitle="Catch live games all season long"
      networkSet="baseball"
      league="mlb"
      showRSN={true}
      video={videos.mlbtv.videoUrl}
      matchtickerSportId={sportIds.Baseball}
      matchtickerLeagueName="MLB"
      matchtickerLeagueId={leagueIds.MLB}
      highlightImage="https://assets-imgx.fubo.tv/marketing/lp/images/devices/mlb-tv-phone.png?ch=width&auto=format,compress"
      highlightHeadline="Get MLB.TV with Fubo"
      highlightSubtitle="See every out-of-market MLB team in action in over 2,000 live games this season. Watch them all live from your TV, phone & other devices."
      highlightUrlParams={[{ offer: ratePlanCodes.mlbtv_mo }]}
      caRedirectUrl="/ca/mlb-tv-ca/"
      sportId={sportIds.Baseball}
      leagueId={leagueIds.MLB}
      hasFanduelPlanCards={showFDPlanCards}
      fanduelRSNData={rsnData}
    />
  )
}
